export enum SpinnerSize {
  Small,
  Normal,
  Inline,
}
